import { useEffect, useState } from 'react';

import { Snackbar, Alert } from '@mui/material';
import { WarningCircle, X } from '@phosphor-icons/react';

import { useValidationError } from '@/contexts/ValidationErrorContext';

const GlobalValidationError = () => {
  const { validationError, clearValidationError } = useValidationError();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (validationError) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [validationError]);

  return (
    <Snackbar
      open={isVisible}
      autoHideDuration={5000}
      onClose={clearValidationError}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={clearValidationError}
        severity="error"
        variant="standard"
        icon={<WarningCircle weight="bold" />}
        slotProps={{
          closeButton: {
            sx: {
              p: 0.5,
              color: 'inherit',
            }
          }
        }}
        slots={{
          closeIcon: X
        }}
      >
        {validationError}
      </Alert>
    </Snackbar>
  );
};

export default GlobalValidationError;
 